import { Component, HostListener, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TenantDto } from '@models/ApiResponse/tenant';
import { AppError } from '@models/appError';
import { LmsApi } from '@services/_api/lms-api';
import {
  ApiHttpErrorService,
  AuthenticationService,
  ReloadService,
} from '@services/index';
import { LearnershipSelectorService } from '@services/learnership-selector.service';
import { finalize, first } from 'rxjs/operators';

@Component({
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  submitted = false;
  returnUrl: string;
  error = '';
  loggingIn = false;
  tenantSubDomainName: string;
  tenant: TenantDto;
  user: LmsApi.AuthenticateResponse;
  showPassword = false;

  constructor(
    public reloadService: ReloadService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private httpErrorService: ApiHttpErrorService,
    private learnershipSelectorService: LearnershipSelectorService
  ) {
    this.tenant = this.authenticationService.currentTenantValue;
    this.user = this.authenticationService.currentUserValue;
    if (this.user && this.tenant && this.user.tenantId === this.tenant.id) {
      switch (this.authenticationService.currentUserValue.role) {
        case LmsApi.Roles.Staff:
        case LmsApi.Roles.Admin:
        case LmsApi.Roles.SuperAdmin:
        case LmsApi.Roles.TenantManager: {
          this.loggingIn = true;
          this.router.navigate([`${this.tenant.subDomainName}/admin`]);
          break;
        }
        case LmsApi.Roles.Student: {
          this.loggingIn = true;
          this.learnershipSelectorService.fetchCurrentUsersLearnerships();
          this.router.navigate([`${this.tenant.subDomainName}/portal`]);
          break;
        }
        default: {
          break;
        }
      }
    }
  }

  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.code === 'Enter' || event.code === 'NumpadEnter') {
      this.login();
    }
  }

  ngOnInit() {
    this.loginForm = this.formBuilder.group({
      username: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required],
    });
  }

  get staffURLToNavTo() {
    return (
      this.route.snapshot.queryParams['returnUrl'] ||
      `${this.tenant.subDomainName}/admin`
    );
  }

  get studentURLToNavTo() {
    return (
      this.route.snapshot.queryParams['returnUrl'] ||
      `${this.tenant.subDomainName}/portal`
    );
  }

  get password() {
    return this.loginForm.get('password');
  }
  get username() {
    return this.loginForm.get('username');
  }

  public apply() {
    this.router.navigate([`${this.tenant.subDomainName}/apply`]);
  }

  public reloadPage() {
    this.reloadService.reloadPage();
  }

  public forgotPassword() {
    this.router.navigate([`${this.tenant.subDomainName}/forgotPassword`]);
  }

  public login() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    }
    this.loggingIn = true;
    this.authenticationService
      .login({
        password: this.password.value,
        email: this.username.value,
        tenantId: this.tenant.id,
      })
      .pipe(
        first(),
        finalize(() => {
          this.loggingIn = false;
        })
      )
      .subscribe(
        () => {
          switch (this.authenticationService.currentUserValue.role) {
            case LmsApi.Roles.Staff:
            case LmsApi.Roles.Admin:
            case LmsApi.Roles.SuperAdmin:
            case LmsApi.Roles.TenantManager: {
              this.router.navigate([this.staffURLToNavTo]);
              break;
            }
            case LmsApi.Roles.Student: {
              this.learnershipSelectorService.fetchCurrentUsersLearnerships();
              this.router.navigate([this.studentURLToNavTo]);
              break;
            }
            default: {
              break;
            }
          }
        },
        (error: AppError) => {
          this.httpErrorService.handle(error);
        }
      );

    // testing znanja login
    // const znanjaDetails = {
    //   email: 'laytonhedges119@gmail.com',
    //   password: 'Lay1245369',
    // };
    // this.httpService
    //   .post('http://localhost:65432/api/poe/znanja/login', znanjaDetails)
    //   .pipe(take(1))
    //   .subscribe(
    //     (res) => {
    //       console.log('Znanja login succesfful and cookie recieved');
    //       const znanjaCookie = JSON.parse(JSON.stringify(res)) as ZnanjaCookie;
    //       sessionStorage.setItem(
    //         'currentUserZnanjaCookie',
    //         JSON.stringify(znanjaCookie)
    //       );
    //       this.getZnanjaCourses();
    //     },
    //     (err) => {
    //       console.log('couldnt log into znanja');
    //     }
    //   );
  }

  // public getZnanjaCourses() {
  //   const znanjaCookie: ZnanjaCookie = JSON.parse(
  //     sessionStorage.getItem('currentUserZnanjaCookie')
  //   );
  //   this.httpService
  //     .post('http://localhost:65432/api/poe/znanja/courses', znanjaCookie)
  //     .pipe(take(1))
  //     .subscribe(
  //       (res) => {
  //         console.log(JSON.parse(JSON.stringify(res)));
  //       },
  //       (err) => {
  //         console.log('couldnt log into znanja');
  //       }
  //     );
  // }

  // public forgotPassword() {
  //   this.httpSpinnerService.show();
  //   this.httpService
  //     .post<ApiResponse<any>>(this.endpointsService.forgotPassword(), {
  //       email: this.username.value,
  //       tenantId: this.tenant.id,
  //     })
  //     .pipe(
  //       take(1),
  //       finalize(() => {
  //         this.httpSpinnerService.hide();
  //       })
  //     )
  //     .subscribe(
  //       () => {
  //         this.toastService.showSuccess(
  //           'Successful! Please check your inbox for further instructions'
  //         );
  //       },
  //       (error: string) => {
  //         this.toastService.showError(error);
  //       }
  //     );
  // }
}
